/**
 * Creating a crew, and the trades that come with it.
 *
 * Two writes, in the only order that is safe: the crew first, so there is an id
 * for `crew_trades` to point at. If the trades fail the crew still exists —
 * better a crew missing a tick than a Create button that did nothing and said
 * so in a sentence about a foreign key.
 *
 * What goes in the row is `crewDraftRow` in packages/core (rule 5), so the
 * modal, and anything that comes later, cannot disagree about it.
 */

import { crewDraftRow, type Crew, type CrewDraft } from "@roof-hawk/core";

import { insertRow } from "./queries";
import { supabase } from "./supabase";

export async function createCrew(draft: CrewDraft): Promise<Crew> {
  const crew = await insertRow<Crew>("crews", crewDraftRow(draft));

  if (draft.tradeIds.length > 0) {
    const { error } = await supabase
      .from("crew_trades")
      .insert(draft.tradeIds.map((id) => ({ crew_id: crew.id, trade_id: id })));
    if (error) throw new Error(error.message);
  }

  return crew;
}
